import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useRouter } from "next/router";
import firebase from "firebase/app";
import "firebase/auth";
import useSettings from "stores/settings";
import { BasicAlert } from "components/Alert";
import { projectFirestore } from "components/ProjectFirestore";
import * as jwt from "jsonwebtoken";

const firebaseConfig = {
  apiKey: process.env.FIREBASE_CONFIG_API_KEY,
  authDomain: process.env.FIREBASE_CONFIG_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_CONFIG_PROJECT_ID,
  storageBucket: process.env.FIREBASE_CONFIG_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_CONFIG_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_CONFIG_APP_ID,
  measurementId: process.env.FIREBASE_CONFIG_MEASUREMENT_ID,
};

if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
}

const auth = firebase.auth();

const SignIn = () => {
  const settings = useSettings();
  const router = useRouter();

  // email, password 값 저장
  const [email] = useState("enkinotest@enkino.com");
  const [password] = useState("123456");
  // const [email, setEmail] = useState("enkinotest@enkino.com");
  // const [password, setPassword] = useState("123456");

  // const [email, setEmail] = useState("er@enkino.com");
  // const [password, setPassword] = useState("123456");
  const signInButtonClick = async () => {
    try {
      const result = await auth.signInWithEmailAndPassword(email, password);
      const { user } = result;
      const email2 = user.email;
      let name = "";
      let photo = "";
      let uid = "";
      // 로그인 성공시 회원 정보 검색해서 이름 저장하기
      const docs = projectFirestore.collection("users").doc(`${email2}`);

      docs
        .get()
        .then((doc) => {
          if (doc.exists) {
            /* 데이터베이스에서 이름정보 가져오기 */
            name = doc.data().name;
            photo = doc.data().photo;
            uid = doc.data().id;

            /* mobx에 저장 & 웹 로컬 스토리지에 로그인 정보 저장 => 토큰 저장하기 */
            settings.login = true;
            settings.email = email2;
            settings.name = name; // DONE: mobx와 firestore의 필드명 최대한 일치 시키기
            settings.photo = photo;
            settings.uid = uid;
            // const tokenValue = { email: email2, name };
            const tokenValue = jwt.sign({ email: email2, name, uid }, process.env.SECRET_CODE, {
              expiresIn: "1d",
            });

            window.localStorage.setItem("aisoToken", tokenValue);

            router.push("/user/market");
          } else {
            const text = "이메일 정보가 없습니다.";
            BasicAlert(text);
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
          BasicAlert(error);
        });
    } catch (error) {
      if (error.code === "auth/user-not-found") {
        const text = "등록된 이메일이 없습니다.";
        BasicAlert(text);
        return;
      }

      if (error.code === "auth/wrong-password") {
        const text = "비밀번호가 일치하지 않습니다.";
        BasicAlert(text);
        return;
      }

      console.log("error :", error);
      const text = "ERROR!";
      BasicAlert(text);
    }
  };

  return (
    <div className="flex items-center auth pt-5 pb-20">
      <div className="row w-100 mx-0 h-full">
        <div className="col-11 col-md-8 col-xl-4 mx-auto py-5 bg-white shadow-sm rounded-3xl">
          <div className="text-left py-5 px-4 px-sm-5">
            <h1 className="text-center mb-5 font-gmarket-bold font-bold text-primary tracking-widest">LOGIN</h1>
            <p className="text-aaa font-gmarket-medium mb-0 keep-words flex justify-center">
              아이소 마켓 오픈 전 입니다. 테스트 이메일로 이용해주세요.
            </p>
            <Form className="pt-4">
              <Form.Group className="bg-gray-input">
                <Form.Control
                  type="email"
                  placeholder="Email"
                  size="lg"
                  className="h-auto font-gmarket-medium"
                  value="enkinotest@enkino.com"
                  readOnly
                  // value={email || ""}
                  // onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="bg-gray-input">
                <Form.Control
                  type="password"
                  placeholder="Password"
                  size="lg"
                  className="h-auto font-gmarket-medium"
                  value="123456"
                  readOnly
                  // value={password || ""}
                  // onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>
              <div className="mt-4">
                <button
                  type="button"
                  className="btn btn-block btn-primary auth-form-btn font-gmarket-medium"
                  onClick={() => signInButtonClick()}
                >
                  Sign In
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
